/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {FC} from 'react';
import {BaseSignUpOptionProps} from '../presentation/SignUp/SignUpOptionFactory';
import Divider from '../primitives/Divider/Divider';
import useTheme from '../../contexts/Theme/useTheme';

/**
 * Divider component for sign-up forms.
 */
const DividerComponent: FC<BaseSignUpOptionProps> = ({component}) => {
  const {theme} = useTheme();
  const config: Record<string, unknown> = component.config || {};
  const text = (config['text'] as string) || '';
  const variant = (component.variant?.toLowerCase() as string) || 'horizontal';

  return (
    <Divider
      key={component.id}
      orientation={variant === 'vertical' ? 'vertical' : 'horizontal'}
      style={{margin: `calc(${theme.vars.spacing.unit} * 2) 0`}}
    >
      {text}
    </Divider>
  );
};

export default DividerComponent;
